import type { CartOverviewProduct } from '../interfaces/CartOverview';

export const formatProducts = (
  products: { id: number; quantity: number }[],
): CartOverviewProduct[] =>
  products.map(({ id, quantity }) => ({
    id,
    quantity,
  }));
